import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/ContactUs.css';
import '../css/about.css';

const LightWims
  = () => {
    const underlineRef = useRef(null);

    useEffect(() => {
      const timer = setTimeout(() => {
        if (underlineRef.current) {
          underlineRef.current.classList.add('animate');
        }
      }, 50);

      return () => clearTimeout(timer);
    }, []);

    return (
      <>
        {/* Hero Section */}
        <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0, top: '-122px' }}>
          <div className="container about-content">
            <div className="row mt-5">
              <div className="col-lg-8 col-md-8 col-12 about-text">
                <h1 className="about-title text-white mt-5">LD-WIMS</h1>
                <h2 className="about-subtitle">Light Well Integrated Management System</h2>
                <div className="about-underline" ref={underlineRef}></div>
                <p className="about-desc text-white">Our Light Well Integrated Management System (Light-WIMS) is the first category of our integrated management system, offering a specialized approach to streamline the well delivery process. Light-WIMS is designed to  provide exceptional services while optimizing time and cost efficiency.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        {/* Content Section */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="row g-5 align-items-center">

              {/* Left Image Column */}
              <div className="col-lg-4">
                <img
                  src="/assets/integrated.jpg"
                  alt="Integrated Drilling"
                  className="img-fluid rounded shadow"
                />
              </div>

              {/* Right Text Column */}
              <div className="col-lg-8">
                <h3 className="fw-bold mb-3">Overview</h3>
                <p className="mb-2">
                  Overview: LD-WIMS is tailored for clients who seek efficient and cost-effective well
                  delivery solutions. In this system, Petrochoice takes on the role of a comprehensive
                  project manager, offering expert engineering supervision to ensure precise control
                  over project timelines and costs. Our clients provide the rigs and materials required for
                  drilling, while Petrochoice manages and coordinates the entire process.
                </p>

              </div>
              <div className="col-lg-12">
                {/* Key Features Section */}
                <h3 className="fw-bold mb-4">Key Features</h3>
                <ul className="list-unstyled">
                  <li><strong>1– Project Management Excellence:</strong> Petrochoice acts as the central hub for project management, overseeing all aspects of the well delivery process. Our expertise ensures that operations are conducted seamlessly, efficiently, and within budgetary constraints.</li>

                  <li className="mt-3"><strong>2– Drilling Expertise and Consultation:</strong> Our experienced team brings extensive drilling knowledge to the table, offering valuable insights and guidance throughout the project. This expertise contributes to safe and effective drilling operations.</li>

                  <li className="mt-3"><strong>3– Cost Optimization:</strong> Light-WIMS focuses on cost control and reduction without compromising safety or quality. Petrochoice’s role in project management includes optimizing expenditure and resource allocation.</li>

                  <li className="mt-3"><strong>4– Engineering Supervision:</strong> Petrochoice provides dedicated engineering supervision to maintain a strict adherence to project timelines and cost estimates. This supervision contributes to efficient decision-making and problem-solving during the drilling process.</li>

                  <li className="mt-3"><strong>5– Client-Centric Approach:</strong> While Petrochoice manages the overall project, we maintain open lines of communication with our clients, ensuring that their specific needs and objectives are met.</li>

                  <li className="mt-3"><strong>6– Rig and Material Management:</strong> Clients are responsible for providing the drilling rigs and materials required for the project. Petrochoice efficiently coordinates and manages these resources to achieve project goals.</li>
                </ul>

                {/* Benefits Section */}
                <div className="row align-items-center mt-5">
                  {/* العمود الخاص بالكلام */}
                  <div className="col-lg-8">
                    <h3 className="fw-bold mb-4">Benefits</h3>
                    <ul className="list-unstyled">
                      <li><strong>Efficiency:</strong> Light-WIMS streamlines the well delivery process, reducing downtime and ensuring timely project completion.</li>
                      <li className="mt-2"><strong>Cost Control:</strong> Our cost-effective approach helps clients manage project expenditures effectively.</li>
                      <li className="mt-2"><strong>Expert Guidance:</strong> Clients benefit from Petrochoice’s drilling expertise and consultation throughout the project.</li>
                      <li className="mt-2"><strong>Safety:</strong> Safety remains a top priority, with Petrochoice overseeing operations to minimize risks.</li>
                      <li className="mt-2"><strong>Client Collaboration:</strong> Petrochoice maintains a collaborative approach, working closely with clients to achieve their objectives.</li>
                    </ul>
                  </div>

                  {/* العمود الخاص بالصورة */}
                  <div className="col-lg-4 text-center">
                    <img
                      src="/assets/light-wims.jpeg"
                      alt="Light WIMS"
                      className="img-fluid rounded shadow"
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </>
    );
  };

export default LightWims;
